import { useEffect, useState } from "react";

import { Table } from "reactstrap";

//Unform e componentes
import ModalTexto from "@/frontend/componentes/ModalTexto";
import Paginacao from "@/frontend/componentes/Paginacao";

//Common
import { fn_formatarDataHora } from "@/common/utils/date";
import { fn_getResultPaginado } from "@/common/utils/paginacao";
import { fn_getSituacaoAprovacao, fn_getTipoAprovacao } from "@/common/siig";

//Util
import { ICONES_BOTAO } from "@/frontend/utils/icones";

//Telas
import TLog_det from "../log/log_det";

function TAprovacoes_list({ aprovacoes = [] }) {
  //### USE STATE ###
  const [modalOpenTexto, setModalOpenTexto] = useState(false);
  const [modalOpenLog, setModalOpenLog] = useState(false);

  const [pageNumber, setPageNumber] = useState(1);
  const [result, setResult] = useState({
    pages: 0,
    count: 0,
    items: [],
    offset: 0,
    limit: 0,
  });

  const [aprovacaoCons, setAprovacaoCons] = useState(null);

  //### USE EFFECT ###
  useEffect(() => {
    setResult(fn_getResultPaginado(pageNumber, aprovacoes));
  }, [pageNumber]);

  //### FUNÇÕES ###
  //Apresenta a situação da aprovação
  function getSituacaoJsx(aprovacao) {
    const situacao = fn_getSituacaoAprovacao(aprovacao.situacao);
    return <div className={situacao.className}>{situacao.label}</div>;
  }
  //### EVENTOS ###
  //OnClick - Botão Comentário
  function handleBotaoComentario(aprovacao) {
    setAprovacaoCons(aprovacao);
    setModalOpenTexto(true);
  }

  //OnClick - Botão Log
  function handleBotaoLog(aprovacao) {
    setAprovacaoCons(aprovacao);
    setModalOpenLog(true);
  }

  return (
    <div>
      <Table responsive>
        <thead>
          <tr>
            <td colSpan="4" className="text-center table-header">
              Solicitação
            </td>

            <td colSpan="5" className="text-center table-header">
              Aprovação
            </td>
          </tr>

          <tr>
            <td width="12%" align="center" className="table-header">
              Data
            </td>

            <td width="15%" className="table-header">
              Usuário
            </td>

            <td className="table-header">Tipo</td>

            <td width="5%" align="center" className="table-header">
              Num. pag.
            </td>

            <td
              width="12%"
              align="center"
              className="table-header border-left-lg"
            >
              Data
            </td>

            <td width="15%" className="table-header">
              Usuário
            </td>

            <td width="8%" align="center" className="table-header">
              Situação
            </td>

            <td width="8%" align="center" className="table-header">
              Comentário
            </td>

            <td width="8%" align="center" className="table-header">
              Log
            </td>
          </tr>
        </thead>

        <tbody>
          {result.items.map((aprov, index) => (
            <tr key={index}>
              <td align="center">
                {fn_formatarDataHora(aprov.data_solicitacao)}
              </td>

              <td>{aprov.usuario_solicitacao.nome}</td>

              <td>
                <span>
                  {fn_getTipoAprovacao(aprov.tipo)?.label}{" "}
                  {aprov?.numero_reajuste ? (
                    <span>({aprov?.numero_reajuste})</span>
                  ) : (
                    ""
                  )}
                </span>
              </td>

              <td align="center" className="fw-bold">
                {aprov?.solicitacao_pag?.num_pag || ""}
              </td>

              <td align="center" className="border-left-lg">
                {fn_formatarDataHora(aprov.data_aprovacao)}
              </td>

              <td>{aprov.usuario_aprovacao?.nome}</td>

              <td align="center">{getSituacaoJsx(aprov)}</td>

              <td align="center">
                {aprov.comentario_aprovacao && (
                  <div
                    className="cursor-pointer"
                    onClick={() => handleBotaoComentario(aprov)}
                  >
                    {ICONES_BOTAO.DETALHAR}
                  </div>
                )}
              </td>

              <td align="center">
                {aprov.logs.length > 0 && (
                  <div
                    className="cursor-pointer"
                    onClick={() => handleBotaoLog(aprov)}
                  >
                    {ICONES_BOTAO.DETALHAR}
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Paginacao
        result={result}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
      />

      {modalOpenTexto && (
        <ModalTexto
          modalOpen={modalOpenTexto}
          toggleModal={() => setModalOpenTexto(!modalOpenTexto)}
          titulo={"Comentário"}
          texto={aprovacaoCons.comentario_aprovacao}
        />
      )}

      {modalOpenLog && (
        <div>
          <TLog_det
            modalOpen={modalOpenLog}
            toggleModal={() => setModalOpenLog(!modalOpenLog)}
            aprovacao={aprovacaoCons}
          />
        </div>
      )}
    </div>
  );
}

export default TAprovacoes_list;
